/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import './ResearchView.css';
import { usePutQuery, useQueryDocument } from '../../networking/useQueryDocument';
import { SenderEnum } from '../../components/chat/Message';
import { useSessionState } from '../../utils/usePersistedState';
import { HighlightedPDFViewer } from '../../components/pdf/HighlightedPDFViewer';
import { SearchableDocViewer } from '../../components/document-utils/SearchableDocViewer';
import { SourcesView } from '../../components/pdf/SourcesView';
import { fromChunkToHighlights } from '../ReportReview/useGetAnomalies';
import { isNonEmpty } from '../../utils/arrayUtils';
import { NumberedDot } from '../../icons/NumberedDot';
import { MarkdownText } from '../../components/base/MarkdownText';
import { ChatView } from '../../components/chat/ChatView';
const DEFAULT_SUMMARY_QUESTION = 'What is the summary of the document?';
export const ResearchView = () => {
    const [researchDocuments, setResearchDocuments] = useSessionState('researchDocuments', []);
    const [viewDocument, setViewDocument] = useState(null);
    const [query] = useState('');
    const [messages, setMessages] = useState([]);
    const [chatMessages, setChatMessages] = useSessionState('researchMessages', []);
    const [highlights, setHighlights] = useState([]);
    const { isLoading: isLoadingQuery, statusCode, data: queryResponse, call: callQueryDocument } = useQueryDocument();
    const { call: callUpdateQuery } = usePutQuery();
    /**
     * Transform a chat Message into a Message to render,
     * with references to the chunks
     * @param param0
     * @returns
     */
    const fromChatMessageToMessage = (answer) => {
        if (!isNonEmpty(answer.sentences)) {
            return {
                text: React.createElement("div", null, 'Could not answer the question'),
                sender: SenderEnum.bot,
            };
        }
        const chunkIds = [];
        for (let i = 0; i < answer.sentences.length; i++) {
            const sentence = answer.sentences[i];
            for (let chunk of sentence.chunks) {
                chunkIds.push(chunk.id);
            }
        }
        const setChunkIds = new Set(chunkIds);
        const uuidToIntMap = new Map();
        let index = 0;
        setChunkIds.forEach((str) => {
            uuidToIntMap.set(str, index + 1);
            index++;
        });
        return {
            messageId: answer.messageId,
            text: (React.createElement("div", null, answer.sentences.map((s, index) => {
                return (React.createElement("div", { key: index, style: { marginTop: 4 } },
                    React.createElement("span", null,
                        React.createElement(MarkdownText, { markdownText: s.sentence, embeddedNode: s.chunks.map((chunk, index) => {
                                const highlights = fromChunkToHighlights(chunk);
                                return (React.createElement(NumberedDot, { key: index, text: uuidToIntMap.get(chunk.id), tooltip: 'See Source', onClick: () => showHighlights(highlights) }));
                            }) }))));
            }))),
            sender: answer.sender,
            feedback: answer.feedback,
            onFeedback: answer.onFeedback,
        };
    };
    const addMessageFeedback = (chatMessage) => {
        if (chatMessage.sender === SenderEnum.bot) {
            chatMessage.onFeedback = (score) => {
                callUpdateQuery({
                    id: chatMessage.messageId,
                    feedback_score: score,
                });
                setChatMessages((prevChatMessages) => prevChatMessages.map((cm) => (cm.messageId === chatMessage.messageId ? { ...cm, feedback: score } : cm)));
            };
        }
    };
    useEffect(() => {
        if (isNonEmpty(chatMessages)) {
            const messages = [];
            for (let chatMessage of chatMessages) {
                addMessageFeedback(chatMessage);
                messages.push(fromChatMessageToMessage(chatMessage));
            }
            setMessages(messages);
        }
    }, []);
    useEffect(() => {
        if (statusCode === 413) {
            const errorMessage = { text: 'Please select one source document for the summary', sender: SenderEnum.bot };
            setMessages([...messages, errorMessage]);
            return;
        }
        if (queryResponse) {
            const messageId = queryResponse.query_id;
            const chatMessage = {
                messageId,
                sentences: queryResponse.answer,
                sender: SenderEnum.bot,
            };
            addMessageFeedback(chatMessage);
            const newMessage = fromChatMessageToMessage(chatMessage);
            setMessages([...messages, newMessage]);
            setChatMessages([...chatMessages, chatMessage]);
        }
    }, [queryResponse]);
    /**
     * Submit the query to the API, and asynchronously invoke the endpoint
     * @param query
     * @returns
     */
    const submitQuery = async (query) => {
        const documentIds = researchDocuments.filter((doc) => !doc.isExcluded).map((doc) => doc.id);
        if (documentIds.length === 0) {
            alert('Please select at least one source document for the summary');
            return;
        }
        const newMessage = { text: query, sender: SenderEnum.user };
        if (query === DEFAULT_SUMMARY_QUESTION && documentIds.length !== 1) {
            const errorMessage = { text: 'Please select one source document for the summary', sender: SenderEnum.bot };
            setMessages([...messages, newMessage, errorMessage]);
            return;
        }
        setMessages([...messages, newMessage]);
        setChatMessages([
            ...chatMessages,
            {
                sentences: [{ sentence: query, chunks: [] }],
                sender: SenderEnum.user,
            },
        ]);
        callQueryDocument({ query: query, document_ids: documentIds });
    };
    const onViewDocument = (document) => {
        setViewDocument(document);
    };
    const showHighlights = (highlights) => {
        let document = null;
        if (isNonEmpty(highlights)) {
            for (let doc of researchDocuments) {
                if (doc.id === highlights[0].document_id) {
                    document = doc;
                    break;
                }
            }
        }
        setHighlights(highlights);
        setViewDocument(document);
    };
    return (React.createElement("div", { className: `query-container split`, style: { height: '90vh' } },
        React.createElement("div", { className: "query-section" },
            React.createElement(ChatView, { isLoading: isLoadingQuery, messages: messages, chatRecommendations: [
                // { text: 'What is the summary of the document?' },
                // { text: 'Is this report compliant with the industry standard?' },
                // { text: 'What are the mandatory requirements for the inspection?' },
                ], shortcutButtons: [
                    {
                        text: DEFAULT_SUMMARY_QUESTION,
                        onClick: () => submitQuery(DEFAULT_SUMMARY_QUESTION),
                        disabled: researchDocuments.length === 0 || isLoadingQuery,
                        style: {
                            paddingTop: 8,
                            paddingBottom: 8,
                            marginTop: 12,
                            marginBottom: 12,
                            backgroundColor: 'white',
                            textAlign: 'center',
                            borderRadius: 12,
                            borderWidth: 0,
                        },
                    },
                ], disabled: researchDocuments.length === 0 || isLoadingQuery, initialText: query, handleSubmit: submitQuery })),
        React.createElement("div", { className: "pdf-section query-pdf-section", style: { borderStyle: 'solid', borderWidth: 1, borderRight: 0, borderTop: 0, borderBottom: 0 } }, viewDocument ? (isNonEmpty(highlights) ? (React.createElement(HighlightedPDFViewer, { document: viewDocument, highlights: highlights, onClose: () => {
                setHighlights([]);
                setViewDocument(null);
            } })) : (React.createElement(SearchableDocViewer, { document: viewDocument, onClose: () => setViewDocument(null) }))) : (React.createElement(SourcesView, { documents: researchDocuments, setDocuments: setResearchDocuments, onViewDocument: onViewDocument })))));
};
// export default withAuthenticationRequired(ResearchView, {
//   onRedirecting: () => <Loading />,
// });
